(function () {
  'use strict';

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-rvrn-price-tools]').forEach(function (root) {
      if (window.RVRNBuilder) window.RVRNBuilder.bindExternalCtas(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
